/*
 * @Author: 陈大仙人
 * @Date: 2022-07-14 16:33:51
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2023-08-04 09:30:01
 * @FilePath: /akx-pc-main/src/login/api/user/index.js
 */
import http from '../../../util/http.js';
export function checkLogin(options) {
    options.url = '/bee/user/user/checkLogin?APP_SOURCE=2'
    return http.get(options)
}
export function getCurrentVersion(options) {
    options.url = '/version/queryCurrentVersion'
    return http.post(options)
}
export function login(options) {
    options.url = '/bee/user/user/loginByAccount'
    options.failTip = false
    return http.post(options)
}

export function selectService(options) {
    options.url = '/bee/user/user/selectService'
    return http.post(options)
}

export function logout(options) {
    options.url = '/bee/user/user/logout'
    return http.post(options)
}

export function getVersion(options) {
    options.url = '/version/queryCurrentVersion'
    return http.post(options)
}
export function getService(options) {
    options.url = '/bee/user/service/getBySId'
    return http.post(options)
}

export function register(options) {
    options.url = '/employee/register'
    options.failTip = false
    return http.post(options)
}

export function getCode(options) {
    options.url = '/employee/sendSMS'
    return http.get(options)
}

export function getWxLoginState(options) {
    options.url = '/user/common/loginByWechatKey'
    return http.get(options)
}

export function updatePwd(options) {
    options.url = '/user/updatePwd'
    return http.get(options)
}